import controller from './profile.controller';
import template from './profile.html';
import './profile.scss';
/**
 * @ngdoc component
 * @name profile
 * @description
 * The profile component of the app.
 *
 * @memberof profile
 */
export default {
  /**
   * The controller class for the component.
   * @type {ProfileController}
   */
  controller,
  /**
   * The HTML template for the component.
   * @type {String}
   */
  template,
};



// WEBPACK FOOTER //
// ./src/frontend/modules/profile/components/profile/profile.component.js